const initRouteInfo = () => ({
  Breadcrumbs: null,
  Filtr: {},
  Tytul: null,
});
export default initRouteInfo;
